import React from "react";
import { useOutletContext } from "react-router-dom";
import { useRunData, useRunPicker } from "./useRunData";
import { PendingBox } from "./Pending";

export default function TabSentiment() {
  const { report, reportId } = useOutletContext();
  const [runNumber, setRunNumber, runs] = useRunPicker(report);
  const { data, pending, error } = useRunData(reportId, runNumber, { includeAggregationsOnly: true });
  const s = data?.sentimentAnalysis;

  return (
    <div>
      <div className="run-picker">
        <label>Run:
          <select value={runNumber || ""} onChange={(e) => setRunNumber(Number(e.target.value))}>
            {runs.slice().reverse().map((r) => (
              <option key={r.runNumber} value={r.runNumber}>#{r.runNumber}</option>
            ))}
          </select>
        </label>
      </div>
      {error && <div className="error-message">{error}</div>}
      {pending && <PendingBox height={160} />}
      {!pending && data && !s && <div>No sentiment data — this run has no client mentions.</div>}
      {!pending && s && (
        <>
          <p>Overall sentiment: <strong>{s.overall_sentiment}</strong> (confidence {Math.round((s.confidence || 0) * 100)}%)</p>
          <h3>Themes</h3>
          <ul>
            {(s.themes || []).map((t, i) => (
              <li key={i}><strong>{t.theme}</strong> — {t.sentiment} ({t.frequency}): {t.summary}</li>
            ))}
          </ul>
          <h3>Strengths</h3>
          <ul>{(s.key_strengths || []).map((k, i) => <li key={i}>{k}</li>)}</ul>
          <h3>Concerns</h3>
          <ul>{(s.key_concerns || []).map((k, i) => <li key={i}>{k}</li>)}</ul>
        </>
      )}
    </div>
  );
}
